import React from 'react'
import { clsx } from 'clsx'

const STATUS_CONFIG: Record<number, { text: string; className: string }> = {
  1: { text: 'Ожидает подтверждения', className: 'bg-warning-50 text-warning-700' },
  2: { text: 'Оплачен (демо)', className: 'bg-success-50 text-success-700' },
  3: { text: 'Аннулирован', className: 'bg-gray-100 text-gray-800' },
}

interface Props {
  status: number
  statusName?: string | null
}

export const InvoiceStatusBadge: React.FC<Props> = ({ status, statusName }) => {
  const config = STATUS_CONFIG[status] || {
    text: statusName || 'Неизвестно',
    className: 'bg-gray-100 text-gray-800',
  }

  return (
    <span
      className={clsx(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
        config.className
      )}
    >
      {config.text}
    </span>
  )
}
